import React from 'react';
import { IntersectionOptions } from 'react-intersection-observer';

import useSectionInView from '@/tracks/hooks/useSectionView';

type Props = {
  height?: number | string;
  className?: string;
  impTrackingT2?: () => void;
  clickTrackingT2?: () => void;
  impTrackingT1?: () => void;
  inviewOptions?: IntersectionOptions;
  dataTestId?: string;
};

const ImpTracker: React.FC<Props> = props => {
  const { impTrackingT2, clickTrackingT2, impTrackingT1, height, className, inviewOptions } = props;

  const { ref } = useSectionInView(inviewOptions, {
    inviewCallBack: () => {
      impTrackingT2?.();
      impTrackingT1?.();
    }
  });

  return (
    <div
      data-testid={props.dataTestId}
      className={className}
      style={{ height }}
      ref={ref}
      onClick={() => {
        clickTrackingT2?.();
      }}>
      {props?.children}
    </div>
  );
};

export default ImpTracker;
